module.exports = __webpack_public_path__ + "static/media/High-Performance.a3e306ca.jpg";